.container {
  display: flex;
  gap: 1rem;
  margin-top: 0.8rem;
}

.files-body-item-descr {
  display: flex;
  color: #9d9d9d;
  font-size: 1.2rem;

  @media screen and (min-width: $bp-small) {
    font-size: 1.2rem;
  }
}

.logo {
  margin-right: 0.4rem;

  @media screen and (min-width: $bp-small) {
    margin-right: 0.8rem;
  }
}
